<template>
    <div class="card"
        :class="[
            className,
            padding === 'dense' ? 'card--dense' : '',
            padding === 'micro' ? 'card--micro' : '',
            isCollapsible ? 'card--collapsible' : '',
            isClickable ? 'card--clickable' : '',
            scrollConfig.use ? 'card--scroll' : '',
            scrollConfig.subtle && scrollConfig.use ? 'card--scroll-subtle' : ''
        ]"
        :style="{
            height: scrollConfig.use && scrollConfig.height ? scrollConfig.height + 'px' : null,
            maxHeight: scrollConfig.use && scrollConfig.maxHeight ? scrollConfig.maxHeight + 'px' : null
        }"
    >
        <!-- Only use card_header if a title is provided -->
        <header v-if="title" 
            class="card_header card_inner"
            :class="{
                'card_header--divided': useHeaderDivider
            }"
        >
            <div class="dock dock--nowrap dock--full">
                <div class="dock_item">
                    <div v-if="isCollapsible">
                        <!-- collapse icon -->
                        <BaseIcon v-show="isCollapsed" icon="carat-down-no-frame" />
                        <BaseIcon v-show="!isCollapsed" icon="carat-up-no-frame" />
                        <!-- collapse icon -->
                    </div>

                    <BaseTextHeader v-if="title.length"
                        class="card_title"
                        :level="titleLevel"
                    >
                        {{title}}
                    </BaseTextHeader>
                </div>
                <div class="dock_item">
                    <slot name="cardOptions"></slot>
                    <BaseIcon v-if="isDismissable"
                        class="card_option"
                        size="small"
                        icon="close"
                        @click.native="$emit('dismiss')"
                    />              
                </div>  
            </div>
        </header>

        <div class="card_content">
            <slot name="body"></slot>
        </div>

        <footer v-if="useFooter" class="card_footer">
            <div class="card_inner">
                <slot name="footer"></slot>
            </div>
        </footer>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            default: ''
        },
        // style props
        titleLevel: {
            type: Number,
            default: 2
        },
        padding: {
            type: String,
            default: 'normal'
        },
        isDismissable: {
            type: Boolean,
            default: false
        },
        scrollConfig: {
            type: Object,
            default: () => ({
                use: false,
                height: 0
            })
        },
        isCollapsible: {
            type: Boolean,
            default: false
        },
        isClickable: {
            type: Boolean,
            default: false
        },
        useHeaderDivider: {
            type:Boolean,
            default:false
        },
        useFooter: {
            type: Boolean,
            default: false
        },
        // state props
        isCollapsed: {
            type: Boolean,
            default: true
        },
        className: {
            type: String,
            default: ''
        }
    },
    data () {
        return {
            testprop: 'This is a test!',
        };
    }
};
</script>